import type { Form } from '@gofranz/formshive-common';
import { Container, Skeleton, Stack } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FieldEditor } from '../../../components/Form/FieldEditor/FieldEditor';
import { useRustyState } from '../../../state';

export function AccountFormFieldsPage() {
  const { api } = useRustyState.getState();
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const [form, setForm] = useState<Form | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getForm = async () => {
      if (!uuid) {
        setIsLoading(false);
        return;
      }
      try {
        setIsLoading(true);
        const res = await api.getForm(uuid);
        if (res) setForm(res);
      } finally {
        setIsLoading(false);
      }
    };
    getForm();
  }, [uuid]);

  const goBack = () => {
    if (uuid) {
      navigate(`/account/forms/${uuid}`);
    } else {
      navigate('/account/forms');
    }
  };

  const handleSave = async (specs: string) => {
    if (!uuid) return;
    await api.updateFormSpecs(uuid, { specs });
    navigate(`/account/forms/${uuid}`);
  };

  if (isLoading) {
    return (
      <Container fluid>
        <Stack gap="md" p="md">
          <Skeleton height={64} />
          <Skeleton height={400} />
        </Stack>
      </Container>
    );
  }

  if (!form) {
    return (
      <Container fluid>
        <Stack p="md">
          <div>Form not found</div>
        </Stack>
      </Container>
    );
  }

  return (
    <Container fluid p={0}>
      <FieldEditor
        formTitle={form.title}
        initialSpec={form.specs || undefined}
        onSave={handleSave}
        onCancel={goBack}
      />
    </Container>
  );
}
